import { useEffect } from "react";
import type { ToolListItem } from "src/pods/toolkitData/components/EditableSetup";
import logEvent from "src/utils/logEvent";
import styles from "./DirectionsSenderDisplay.module.css";

type DirectionsSenderDisplayProps = {
  title?: string;
  list?: ToolListItem[];
};

export default function DirectionsSenderDisplay({ title, list }: DirectionsSenderDisplayProps) {
  // Mirrors DirectionsDisplay's lifecycle events (both fire the same names).
  // Pre-migration behavior — kept intact.
  useEffect(() => {
    logEvent({ eventName: "directions.result.open" });
    return () => {
      logEvent({ eventName: "directions.result.close" });
    };
  }, []);

  return (
    <article className={styles.card}>
      {title && <h1 className={styles.title}>{title}</h1>}
      <ol className={styles.list}>
        {list?.map((item, idx) => (
          <li key={idx} className={styles.item}>
            <span className={styles.itemCount}>{idx + 1}</span>
            <p className={styles.itemText}>{item.text}</p>
          </li>
        ))}
      </ol>
    </article>
  );
}
